import { Component } from '@angular/core';
import { NavController, NavParams, ViewController } from 'ionic-angular';



/**
 * Generated class for the InRoomDiningOrderModal page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  templateUrl: 'room-service-order.html',
})
export class RoomServiceOrderModal {

  order;
  fullName;
  roomNumber;

  constructor(
    public navCtrl: NavController,
    public viewCtrl: ViewController,
    public navParams: NavParams,
  ) {
    this.order = navParams.get('order');
  }

  orderSum(){
    let total = this.order.reduce((prev, curr) => {
      return prev + parseFloat(curr.ird_item_prices[0].amount);
    }, 0);

    return {
      price: (total).toFixed(2),
      tax: (total * 0.13).toFixed(2),
      total: (total * 1.13).toFixed(2)
    }
  }

  removeFromOrder(item){
    let ind = this.order.indexOf(item);
    this.order.splice(ind, 1);
  }

  submitOrder(){
    this.viewCtrl.dismiss(this.order);
  }

}



// WEBPACK FOOTER //
// ./src/pages/room-service/room-service-order.ts